export const translations = {
  en: {
    mesh3d: {
      title: "3D Model (GLB)",
      ready: "Review Required",
      cta: "Generate 3D Mesh",
      desc: "Generate a preliminary visual GLB mesh from project imagery. This is not parametric CAD, manufacturing geometry, or verified interoperability.",
      queued: "Queued…",
      uploading: "Uploading images…",
      generating: "Generating 3D mesh…",
      finalizing: "Finalizing…",
      working: "Working…",
      duration: "Processing time varies.",
      download: "Download GLB",
      openTab: "Open in New Tab",
      compat: "Visual GLB mesh — verify geometry and import behavior in target tools.",
      errorPrefix: "Error: ",
      errorBalance: "The 3D generation service is temporarily unavailable. Try again later or contact support.",
      errorNotConfigured: "3D generation is unavailable for this deployment. Contact support.",
      noViews: "Concept images are not ready yet. Try again after they are generated.",
      timeout: "Timed out (3 min)"
    },
    nav: {
      platform: "Platform",
      engines: "Validation",
      projects: "Projects",
      demo: "Design Studio",
      smartGlasses: "Smart Glasses",
      applications: "Applications",
      contact: "Contact",
      solutions: "Solutions",
      ar: "AR System (Beta)",
      scanner: "Scanner",
      companies: "Companies",
      training: "Training",
      investors: "Investors",
      more: "More",
      faq: "FAQ",
      blog: "Blog",
      caseStudies: "Workflow Scenarios",
      integrations: "Integrations",
      pricing: "Pricing",
      about: "About Us"
    },
    hero: {
      badge: "AI-Powered Platform",
      title1: "Turn Ideas into",
      titleHighlight: "Structured Engineering",
      title2: "Projects",
      subtitle: "Describe your idea; the system helps structure requirements, preliminary CAD-oriented outputs and draft production plans. Qualified human validation is required.",
      cta1: "Try Live Demo",
      cta2: "Contact Us",
      stat1: "Pilot",
      stat1Label: "Measurement Required",
      stat2: "Preliminary",
      stat2Label: "Cost Estimates",
      stat3: "Traceable",
      stat3Label: "Review Gates",
      stat4: "12",
      stat4Label: "Interface Languages",
    },
    about: {
      title: "What is",
      titleHighlight: "Nexus Design AI",
      subtitle: "Even if you don't know coding, engineering, or design tools, you can still build complex projects.",
      description: "Just describe what you want, and the system automatically creates:",
      feature1: "3D models and assembly-sequence visualization",
      feature2: "Simulations & optimization",
      feature3: "Preliminary technical documentation (validation required)",
      feature4: "Comprehensive market analysis",
      conclusion: "Nexus Design AI provides preliminary decision-support outputs intended to accelerate early engineering work; results require qualified human validation."
    },
    engines: {
      sectionTitle: "Core Technology",
      title: "Traceable",
      titleHighlight: "Validation Workflows",
      subtitle: "Each engine specializes in a specific phase of the project lifecycle, working together in a continuous feedback loop."
    },
    smartGlasses: {
      sectionTitle: "Next-Level Innovation",
      title: "Smart Glasses",
      titleHighlight: "Integration",
      subtitle: "Roadmap concept for integration with compatible industrial smart-glasses hardware.",
      description: "Potential pilot workflows, subject to hardware integration and qualified human review:",
      feature1: "Assist with scanning machines or components",
      feature2: "Flag possible anomalies for qualified review",
      feature3: "Present draft repair guidance",
      feature4: "Draft replacement-part concepts for engineering review",
      feature5: "Display preliminary measurements and analysis",
      conclusion: "Roadmap concept only — not a validated field fault-detection, repair, or safety system.",
    },
    applications: {
      sectionTitle: "Industries",
      title: "Enterprise",
      titleHighlight: "Applications",
      subtitle: "Nexus Design AI transforms project development across multiple industries."
    },
    demo: {
      sectionTitle: "Live Demo",
      title: "Experience",
      titleHighlight: "AI Power",
      subtitle: "Describe your project and watch our AI engines analyze it in real-time.",
      placeholder: "Describe your project idea...",
      analyze: "Analyze Project",
      analyzing: "Analyzing...",
      results: "Analysis Results",
      enginesUsed: "AI Engines Used"
    },
    video: {
      sectionTitle: "See It In Action",
      title: "Platform",
      titleHighlight: "Demo Video",
      subtitle: "Watch how Nexus Design AI turns ideas into structured preliminary engineering projects."
    },
    contact: {
      sectionTitle: "Get In Touch",
      title: "Start Your",
      titleHighlight: "Journey",
      subtitle: "I'm opening conversations with technology leaders, investors, and innovation teams.",
      name: "Full Name",
      email: "Email Address",
      company: "Company (Optional)",
      interest: "Interest Type",
      interestOptions: {
        partnership: "Partnership",
        investment: "Investment",
        licensing: "Licensing",
        demo: "Product Demo",
        other: "Other"
      },
      message: "Your Message",
      submit: "Send Message",
      sending: "Sending...",
      success: "Thank you! We will contact you soon.",
      founder: "Founder & Inventor",
      email_label: "Email"
    },
    footer: {
      tagline: "A patent-pending voice-and-text engineering platform that turns ideas into preliminary, reviewable outputs.",
      product: "Product",
      legal: "Legal",
      privacy: "Privacy Policy",
      terms: "Terms of Service",
      copyright: "All rights reserved.",
      caseStudies: "Workflow Scenarios"
    },
    common: {
      login: "Login",
      logout: "Logout",
      dashboard: "Dashboard",
      settings: "Settings",
      language: "Language",
      save: "Save",
      cancel: "Cancel",
      delete: "Delete",
      edit: "Edit",
      create: "Create",
      search: "Search",
      loading: "Loading...",
      error: "Error",
      success: "Success"
    }
  },
  tr: {
    mesh3d: {
      title: "3D Model (GLB)",
      ready: "İnceleme Gerekli",
      cta: "3D Modele Dönüştür",
      desc: "Proje görsellerinden ön nitelikte bir GLB görsel mesh oluşturun. Bu çıktı parametrik CAD, üretim geometrisi veya doğrulanmış araç uyumluluğu değildir.",
      queued: "Kuyrukta…",
      uploading: "Görseller yükleniyor…",
      generating: "3D mesh üretiliyor…",
      finalizing: "Sonlandırılıyor…",
      working: "Çalışıyor…",
      duration: "İşlem süresi değişebilir.",
      download: "GLB İndir",
      openTab: "Yeni Sekmede Aç",
      compat: "Görsel GLB mesh — geometriyi ve hedef araçtaki içe aktarmayı doğrulayın.",
      errorPrefix: "Hata: ",
      errorBalance: "3D üretim hizmeti geçici olarak kullanılamıyor. Daha sonra tekrar deneyin veya destekle iletişime geçin.",
      errorNotConfigured: "Bu dağıtımda 3D üretim kullanılamıyor. Destekle iletişime geçin.",
      noViews: "Konsept görselleri henüz hazır değil. Görseller oluşturulduktan sonra tekrar deneyin.",
      timeout: "Zaman aşımı (3dk)"
    },
    nav: {
      platform: "Platform",
      engines: "Doğrulama",
      projects: "Projeler",
      demo: "Tasarım Stüdyosu",
      smartGlasses: "Akıllı Gözlük",
      applications: "Uygulamalar",
      contact: "İletişim",
      solutions: "Çözümler",
      ar: "AR Sistemi (Beta)",
      scanner: "Tarayıcı",
      companies: "Şirketler",
      training: "Eğitim",
      investors: "Yatırımcılar",
      more: "Diğer",
      faq: "SSS",
      blog: "Blog",
      caseStudies: "İş Akışı Senaryoları",
      integrations: "Entegrasyonlar",
      pricing: "Fiyatlandırma",
      about: "Hakkımızda"
    },
    hero: {
      badge: "AI Destekli Platform",
      title1: "Fikirleri",
      titleHighlight: "Ön Mühendislik Odaklı",
      title2: "Projelere Dönüştürün",
      subtitle: "Fikrinizi anlatın; sistem yapılandırılmış gereksinimler, ön CAD-yönelimli çıktılar ve taslak üretim planları oluşturmaya yardımcı olur. Nitelikli insan doğrulaması gerekir.",
      cta1: "Canlı Demo Dene",
      cta2: "Bize Ulaşın",
      stat1: "Pilot",
      stat1Label: "Ölçüm Gerekli",
      stat2: "Ön Tahmin",
      stat2Label: "Maliyet Tahmini",
      stat3: "İzlenebilir",
      stat3Label: "İnceleme Kapıları",
      stat4: "12",
      stat4Label: "Arayüz Dili",
    },
    about: {
      title: "Nedir",
      titleHighlight: "Nexus Design AI",
      subtitle: "Kodlama, mühendislik veya tasarım araçları bilmeseniz bile karmaşık projeler inşa edebilirsiniz.",
      description: "Sadece ne istediğinizi anlatın, sistem otomatik olarak oluşturur:",
      feature1: "3D modeller ve montaj sırası görselleştirmesi",
      feature2: "Simülasyonlar & optimizasyon",
      feature3: "Ön teknik dokümantasyon (doğrulama gerekli)",
      feature4: "Kapsamlı pazar analizi",
      conclusion: "Nexus Design AI, erken mühendislik çalışmalarını hızlandırmayı amaçlayan ön karar-destek çıktıları sunar; sonuçlar nitelikli insan doğrulaması gerektirir."
    },
    engines: {
      sectionTitle: "Temel Teknoloji",
      title: "8 Özelleştirilmiş",
      titleHighlight: "AI Motoru",
      subtitle: "Her motor, proje yaşam döngüsünün belirli bir aşamasında uzmanlaşmıştır."
    },
    smartGlasses: {
      sectionTitle: "Yeni Nesil İnovasyon",
      title: "Akıllı Gözlük",
      titleHighlight: "Entegrasyonu",
      subtitle: "Uyumlu endüstriyel akıllı gözlük donanımıyla entegrasyon yol haritası konsepti.",
      description: "Donanım entegrasyonu ve nitelikli insan incelemesine bağlı olası pilot iş akışları:",
      feature1: "Makine veya bileşen taramasına yardımcı olma",
      feature2: "Olası anomalileri uzman incelemesi için işaretleme",
      feature3: "Taslak onarım rehberliği sunma",
      feature4: "Mühendislik incelemesi için yedek parça konseptleri hazırlama",
      feature5: "Ön ölçüm ve analizleri gösterme",
      conclusion: "Yalnızca yol haritası konseptidir — doğrulanmış saha arıza tespit, onarım veya güvenlik sistemi değildir.",
    },
    applications: {
      sectionTitle: "Endüstriler",
      title: "Kurumsal",
      titleHighlight: "Uygulamalar",
      subtitle: "Nexus Design AI, birden fazla endüstride proje geliştirmeyi dönüştürür."
    },
    demo: {
      sectionTitle: "Canlı Demo",
      title: "AI Gücünü",
      titleHighlight: "Deneyimleyin",
      subtitle: "Projenizi tanımlayın ve AI motorlarımızın gerçek zamanlı analiz etmesini izleyin.",
      placeholder: "Proje fikrinizi anlatın...",
      analyze: "Projeyi Analiz Et",
      analyzing: "Analiz Ediliyor...",
      results: "Analiz Sonuçları",
      enginesUsed: "Kullanılan AI Motorları"
    },
    video: {
      sectionTitle: "İş Başında Görün",
      title: "Platform",
      titleHighlight: "Demo Videosu",
      subtitle: "Nexus Design AI'ın fikirleri yapılandırılmış ön mühendislik projelerine nasıl dönüştürdüğünü izleyin."
    },
    contact: {
      sectionTitle: "İletişime Geçin",
      title: "Yolculuğunuza",
      titleHighlight: "Başlayın",
      subtitle: "Teknoloji liderleri, yatırımcılar ve inovasyon ekipleriyle görüşmelere açığım.",
      name: "Ad Soyad",
      email: "E-posta Adresi",
      company: "Şirket (İsteğe Bağlı)",
      interest: "İlgi Alanı",
      interestOptions: {
        partnership: "Ortaklık",
        investment: "Yatırım",
        licensing: "Lisanslama",
        demo: "Ürün Demosu",
        other: "Diğer"
      },
      message: "Mesajınız",
      submit: "Mesaj Gönder",
      sending: "Gönderiliyor...",
      success: "Teşekkürler! En kısa sürede sizinle iletişime geçeceğiz.",
      founder: "Kurucu & Mucit",
      email_label: "E-posta"
    },
    footer: {
      tagline: "Fikirleri incelenebilir ön mühendislik çıktılarına dönüştüren, patent başvurusu bekleyen sesli ve yazılı mühendislik platformu.",
      product: "Ürün",
      legal: "Yasal",
      privacy: "Gizlilik Politikası",
      terms: "Kullanım Şartları",
      copyright: "Tüm hakları saklıdır.",
      caseStudies: "İş Akışı Senaryoları"
    },
    common: {
      login: "Giriş",
      logout: "Çıkış",
      dashboard: "Panel",
      settings: "Ayarlar",
      language: "Dil",
      save: "Kaydet",
      cancel: "İptal",
      delete: "Sil",
      edit: "Düzenle",
      create: "Oluştur",
      search: "Ara",
      loading: "Yükleniyor...",
      error: "Hata",
      success: "Başarılı"
    }
  },
  de: {
    mesh3d: {
      title: "3D-Modell (GLB)",
      ready: "Prüfung erforderlich",
      cta: "3D-Modell generieren",
      desc: "Erzeugt ein vorläufiges visuelles GLB-Mesh aus Projektbildern. Kein parametrisches CAD, keine Fertigungsgeometrie und keine validierte Interoperabilität.",
      queued: "In Warteschlange…",
      uploading: "Bilder werden hochgeladen…",
      generating: "3D-Modell wird generiert…",
      finalizing: "Abschluss…",
      working: "Arbeite…",
      duration: "Bearbeitungszeit variiert.",
      download: "GLB herunterladen",
      openTab: "In neuem Tab öffnen",
      compat: "Visuelles GLB-Mesh — Geometrie und Import im Zielwerkzeug prüfen.",
      errorPrefix: "Fehler: ",
      errorBalance: "Der 3D-Generierungsdienst ist vorübergehend nicht verfügbar. Später erneut versuchen oder Support kontaktieren.",
      errorNotConfigured: "3D-Generierung ist in dieser Bereitstellung nicht verfügbar. Support kontaktieren.",
      noViews: "Konzeptbilder sind noch nicht bereit. Versuchen Sie es nach der Generierung erneut.",
      timeout: "Zeitüberschreitung (3 Min.)"
    },
    nav: {
      platform: "Plattform",
      engines: "KI-Engines",
      projects: "Projekte",
      demo: "Design-Studio",
      smartGlasses: "Smart Glasses",
      applications: "Anwendungen",
      contact: "Kontakt",
      solutions: "Lösungen",
      ar: "AR-Erlebnis",
      scanner: "Scanner",
      companies: "Unternehmen",
      training: "Schulung",
      investors: "Investoren",
      more: "Mehr",
      faq: "FAQ",
      blog: "Blog",
      caseStudies: "Fallstudien"
    },
    hero: {
      badge: "KI-gestützte Plattform",
      title1: "Ideen in",
      titleHighlight: "strukturierte Engineering-",
      title2: "Projekte verwandeln",
      subtitle: "Beschreiben Sie Ihre Idee; das System unterstützt strukturierte Anforderungen, vorläufige CAD-orientierte Ergebnisse und Entwürfe für Produktionspläne. Qualifizierte menschliche Prüfung ist erforderlich.",
      cta1: "Live-Demo testen",
      cta2: "Kontaktieren Sie uns",
      stat1: "Pilot",
      stat1Label: "Messung erforderlich",
      stat2: "Vorläufig",
      stat2Label: "Kostenschätzung",
      stat3: "8",
      stat3Label: "KI-Engines",
      stat4: "12",
      stat4Label: "Oberflächensprachen",
    },
    about: {
      title: "Was ist",
      titleHighlight: "Nexus Design AI",
      subtitle: "Auch ohne Kenntnisse in Programmierung, Ingenieurwesen oder Designtools können Sie komplexe Projekte erstellen.",
      description: "Beschreiben Sie einfach, was Sie möchten, und das System erstellt automatisch:",
      feature1: "3D Ingenieurmodelle",
      feature2: "Simulationen & Optimierung",
      feature3: "Vorläufige technische Dokumentation (Prüfung erforderlich)",
      feature4: "Umfassende Marktanalyse",
      conclusion: "Nexus Design AI liefert vorläufige Entscheidungshilfen für frühe Engineering-Phasen; Ergebnisse erfordern qualifizierte menschliche Prüfung.",
    },
    engines: {
      sectionTitle: "Kerntechnologie",
      title: "8 Spezialisierte",
      titleHighlight: "KI-Engines",
      subtitle: "Jede Engine ist auf eine bestimmte Phase des Projektlebenszyklus spezialisiert."
    },
    smartGlasses: {
      sectionTitle: "Innovation der nächsten Generation",
      title: "Smart Glasses",
      titleHighlight: "Integration",
      subtitle: "Roadmap-Konzept für kompatible industrielle Smart-Glasses-Hardware.",
      description: "Mögliche Pilotabläufe, abhängig von Hardwareintegration und qualifizierter Prüfung:",
      feature1: "Beim Scannen von Maschinen oder Komponenten unterstützen",
      feature2: "Mögliche Anomalien zur fachlichen Prüfung markieren",
      feature3: "Vorläufige Reparaturhinweise anzeigen",
      feature4: "Ersatzteilkonzepte zur Engineering-Prüfung entwerfen",
      feature5: "Vorläufige Messungen und Analysen anzeigen",
      conclusion: "Nur Roadmap-Konzept — kein validiertes Fehlererkennungs-, Reparatur- oder Sicherheitssystem.",
    },
    applications: {
      sectionTitle: "Branchen",
      title: "Unternehmens",
      titleHighlight: "Anwendungen",
      subtitle: "Nexus Design AI transformiert die Projektentwicklung in mehreren Branchen."
    },
    demo: {
      sectionTitle: "Live-Demo",
      title: "KI-Power",
      titleHighlight: "erleben",
      subtitle: "Beschreiben Sie Ihr Projekt und beobachten Sie unsere KI-Engines in Echtzeit.",
      placeholder: "Beschreiben Sie Ihre Projektidee...",
      analyze: "Projekt analysieren",
      analyzing: "Analysiere...",
      results: "Analyseergebnisse",
      enginesUsed: "Verwendete KI-Engines"
    },
    video: {
      sectionTitle: "In Aktion sehen",
      title: "Plattform",
      titleHighlight: "Demo-Video",
      subtitle: "Sehen Sie vorläufige, prüfungspflichtige Engineering-Ausgaben von Nexus Design AI.",
    },
    contact: {
      sectionTitle: "Kontakt aufnehmen",
      title: "Starten Sie Ihre",
      titleHighlight: "Reise",
      subtitle: "Ich bin offen für Gespräche mit Technologieführern, Investoren und Innovationsteams.",
      name: "Vollständiger Name",
      email: "E-Mail-Adresse",
      company: "Unternehmen (Optional)",
      interest: "Interessenbereich",
      interestOptions: {
        partnership: "Partnerschaft",
        investment: "Investition",
        licensing: "Lizenzierung",
        demo: "Produktdemo",
        other: "Andere"
      },
      message: "Ihre Nachricht",
      submit: "Nachricht senden",
      sending: "Wird gesendet...",
      success: "Vielen Dank! Wir werden Sie bald kontaktieren.",
      founder: "Gründer & Erfinder",
      email_label: "E-Mail"
    },
    footer: {
      tagline: "KI-gestützte Plattform für strukturierte, vorläufige Engineering-Ausgaben mit erforderlicher menschlicher Prüfung.",
      product: "Produkt",
      legal: "Rechtliches",
      privacy: "Datenschutz",
      terms: "Nutzungsbedingungen",
      copyright: "Alle Rechte vorbehalten."
    },
    common: {
      login: "Anmelden",
      logout: "Abmelden",
      dashboard: "Dashboard",
      settings: "Einstellungen",
      language: "Sprache",
      save: "Speichern",
      cancel: "Abbrechen",
      delete: "Löschen",
      edit: "Bearbeiten",
      create: "Erstellen",
      search: "Suchen",
      loading: "Wird geladen...",
      error: "Fehler",
      success: "Erfolg"
    }
  },
  fr: {
    mesh3d: {
      title: "Modèle 3D (GLB)",
      ready: "Validation requise",
      cta: "Générer un modèle 3D",
      desc: "Génère un maillage GLB visuel préliminaire à partir des images du projet. Ce n’est ni une CAO paramétrique, ni une géométrie de fabrication, ni une interopérabilité validée.",
      queued: "En attente…",
      uploading: "Téléchargement des images…",
      generating: "Génération du modèle 3D…",
      finalizing: "Finalisation…",
      working: "En cours…",
      duration: "Le délai de traitement varie.",
      download: "Télécharger GLB",
      openTab: "Ouvrir dans un nouvel onglet",
      compat: "Maillage GLB visuel — vérifier la géométrie et l’import dans les outils cibles.",
      errorPrefix: "Erreur : ",
      errorBalance: "Le service de génération 3D est temporairement indisponible. Réessayez plus tard ou contactez le support.",
      errorNotConfigured: "La génération 3D n’est pas disponible pour ce déploiement. Contactez le support.",
      noViews: "Les images conceptuelles ne sont pas encore prêtes. Réessayez après leur génération.",
      timeout: "Délai dépassé (3 min)"
    },
    nav: {
      platform: "Plateforme",
      engines: "Moteurs IA",
      projects: "Projets",
      demo: "Studio de Design",
      smartGlasses: "Lunettes Intelligentes",
      applications: "Applications",
      contact: "Contact",
      solutions: "Solutions",
      ar: "Expérience AR",
      scanner: "Scanner",
      companies: "Entreprises",
      training: "Formation",
      investors: "Investisseurs",
      more: "Plus",
      faq: "FAQ",
      blog: "Blog",
      caseStudies: "Études de cas"
    },
    hero: {
      badge: "Plateforme alimentée par l'IA",
      title1: "Transformez vos idées en",
      titleHighlight: "projets d’ingénierie",
      title2: "structurés",
      subtitle: "Décrivez votre idée; le système aide à structurer les exigences, les résultats préliminaires orientés CAO et les projets de plans de production. Une validation humaine qualifiée est requise.",
      cta1: "Essayer la démo",
      cta2: "Nous contacter",
      stat1: "Pilote",
      stat1Label: "Mesure requise",
      stat2: "Préliminaire",
      stat2Label: "Estimation des coûts",
      stat3: "8",
      stat3Label: "Moteurs IA",
      stat4: "12",
      stat4Label: "Langues d’interface",
    },
    about: {
      title: "Qu'est-ce que",
      titleHighlight: "Nexus Design AI",
      subtitle: "Même sans connaissances en programmation, ingénierie ou outils de conception, vous pouvez créer des projets complexes.",
      description: "Décrivez simplement ce que vous voulez, et le système crée automatiquement:",
      feature1: "Modèles d'ingénierie 3D",
      feature2: "Simulations & optimisation",
      feature3: "Documentation technique préliminaire (validation requise)",
      feature4: "Analyse de marché complète",
      conclusion: "Nexus Design AI fournit des aides préliminaires à la décision; les résultats exigent une validation humaine qualifiée.",
    },
    engines: {
      sectionTitle: "Technologie de base",
      title: "8 Moteurs IA",
      titleHighlight: "Spécialisés",
      subtitle: "Chaque moteur est spécialisé dans une phase spécifique du cycle de vie du projet."
    },
    smartGlasses: {
      sectionTitle: "Innovation de nouvelle génération",
      title: "Lunettes Intelligentes",
      titleHighlight: "Intégration",
      subtitle: "Concept de feuille de route pour du matériel de lunettes industrielles compatible.",
      description: "Flux pilotes potentiels, sous réserve d’intégration matérielle et de validation humaine:",
      feature1: "Aider à scanner des machines ou composants",
      feature2: "Signaler des anomalies possibles pour examen spécialisé",
      feature3: "Présenter des consignes de réparation préliminaires",
      feature4: "Proposer des concepts de pièces pour examen d’ingénierie",
      feature5: "Afficher des mesures et analyses préliminaires",
      conclusion: "Concept de feuille de route uniquement — pas un système validé de détection, réparation ou sécurité.",
    },
    applications: {
      sectionTitle: "Industries",
      title: "Applications",
      titleHighlight: "Entreprise",
      subtitle: "Nexus Design AI transforme le développement de projets dans plusieurs industries."
    },
    demo: {
      sectionTitle: "Démo en direct",
      title: "Découvrez la",
      titleHighlight: "puissance de l'IA",
      subtitle: "Décrivez votre projet et regardez nos moteurs IA l'analyser en temps réel.",
      placeholder: "Décrivez votre idée de projet...",
      analyze: "Analyser le projet",
      analyzing: "Analyse en cours...",
      results: "Résultats de l'analyse",
      enginesUsed: "Moteurs IA utilisés"
    },
    video: {
      sectionTitle: "Voir en action",
      title: "Vidéo démo",
      titleHighlight: "Plateforme",
      subtitle: "Regardez comment Nexus Design AI transforme les idées en projets prêts à produire."
    },
    contact: {
      sectionTitle: "Nous contacter",
      title: "Commencez votre",
      titleHighlight: "voyage",
      subtitle: "Je suis ouvert aux discussions avec les leaders technologiques, investisseurs et équipes d'innovation.",
      name: "Nom complet",
      email: "Adresse e-mail",
      company: "Entreprise (Optionnel)",
      interest: "Type d'intérêt",
      interestOptions: {
        partnership: "Partenariat",
        investment: "Investissement",
        licensing: "Licence",
        demo: "Démo produit",
        other: "Autre"
      },
      message: "Votre message",
      submit: "Envoyer",
      sending: "Envoi en cours...",
      success: "Merci! Nous vous contacterons bientôt.",
      founder: "Fondateur & Inventeur",
      email_label: "E-mail"
    },
    footer: {
      tagline: "La première plateforme vocale-vers-physique au monde. Transformer les idées en designs prêts à produire avec 8 moteurs IA spécialisés.",
      product: "Produit",
      legal: "Juridique",
      privacy: "Politique de confidentialité",
      terms: "Conditions d'utilisation",
      copyright: "Tous droits réservés."
    },
    common: {
      login: "Connexion",
      logout: "Déconnexion",
      dashboard: "Tableau de bord",
      settings: "Paramètres",
      language: "Langue",
      save: "Enregistrer",
      cancel: "Annuler",
      delete: "Supprimer",
      edit: "Modifier",
      create: "Créer",
      search: "Rechercher",
      loading: "Chargement...",
      error: "Erreur",
      success: "Succès"
    }
  },
  es: {
    mesh3d: {
      title: "Modelo 3D (GLB)",
      ready: "Revisión requerida",
      cta: "Generar modelo 3D",
      desc: "Genera una malla GLB visual preliminar a partir de imágenes del proyecto. No es CAD paramétrico, geometría de fabricación ni interoperabilidad validada.",
      queued: "En cola…",
      uploading: "Subiendo imágenes…",
      generating: "Generando modelo 3D…",
      finalizing: "Finalizando…",
      working: "Trabajando…",
      duration: "El tiempo de procesamiento varía.",
      download: "Descargar GLB",
      openTab: "Abrir en pestaña nueva",
      compat: "Malla GLB visual — verifique la geometría y la importación en las herramientas de destino.",
      errorPrefix: "Error: ",
      errorBalance: "El servicio de generación 3D no está disponible temporalmente. Inténtelo más tarde o contacte con soporte.",
      errorNotConfigured: "La generación 3D no está disponible en este despliegue. Contacte con soporte.",
      noViews: "Las imágenes conceptuales aún no están listas. Inténtalo de nuevo cuando se generen.",
      timeout: "Tiempo agotado (3 min)"
    },
    nav: {
      platform: "Plataforma",
      engines: "Motores IA",
      projects: "Proyectos",
      demo: "Estudio de Diseño",
      smartGlasses: "Gafas Inteligentes",
      applications: "Aplicaciones",
      contact: "Contacto",
      solutions: "Soluciones",
      ar: "Experiencia AR",
      scanner: "Escáner",
      companies: "Empresas",
      training: "Formación",
      investors: "Inversores",
      more: "Más",
      faq: "FAQ",
      blog: "Blog",
      caseStudies: "Casos de Estudio"
    },
    hero: {
      badge: "Plataforma impulsada por IA",
      title1: "Convierte ideas en",
      titleHighlight: "proyectos de ingeniería",
      title2: "estructurados",
      subtitle: "Describe tu idea; el sistema ayuda a estructurar requisitos, resultados preliminares orientados a CAD y borradores de producción. Se requiere validación humana cualificada.",
      cta1: "Probar demo",
      cta2: "Contáctenos",
      stat1: "Piloto",
      stat1Label: "Medición requerida",
      stat2: "Preliminar",
      stat2Label: "Estimación de costes",
      stat3: "8",
      stat3Label: "Motores IA",
      stat4: "12",
      stat4Label: "Idiomas de interfaz",
    },
    about: {
      title: "¿Qué es",
      titleHighlight: "Nexus Design AI",
      subtitle: "Sin conocimientos de programación, ingeniería o herramientas de diseño, puedes crear proyectos complejos.",
      description: "Solo describe lo que quieres, y el sistema crea automáticamente:",
      feature1: "Modelos de ingeniería 3D",
      feature2: "Simulaciones y optimización",
      feature3: "Documentación técnica preliminar (requiere validación)",
      feature4: "Análisis de mercado completo",
      conclusion: "Nexus Design AI ofrece apoyo preliminar a decisiones de ingeniería; los resultados requieren validación humana cualificada.",
    },
    engines: {
      sectionTitle: "Tecnología central",
      title: "8 Motores IA",
      titleHighlight: "Especializados",
      subtitle: "Cada motor está especializado en una fase específica del ciclo de vida del proyecto."
    },
    smartGlasses: {
      sectionTitle: "Innovación de próxima generación",
      title: "Gafas Inteligentes",
      titleHighlight: "Integración",
      subtitle: "Concepto de hoja de ruta para hardware industrial de gafas inteligentes compatible.",
      description: "Flujos piloto potenciales, sujetos a integración de hardware y revisión humana:",
      feature1: "Ayudar a escanear máquinas o componentes",
      feature2: "Marcar posibles anomalías para revisión especializada",
      feature3: "Presentar orientación preliminar de reparación",
      feature4: "Crear conceptos de repuestos para revisión de ingeniería",
      feature5: "Mostrar mediciones y análisis preliminares",
      conclusion: "Solo concepto de hoja de ruta — no es un sistema validado de detección, reparación o seguridad.",
    },
    applications: {
      sectionTitle: "Industrias",
      title: "Aplicaciones",
      titleHighlight: "Empresariales",
      subtitle: "Nexus Design AI transforma el desarrollo de proyectos en múltiples industrias."
    },
    demo: {
      sectionTitle: "Demo en vivo",
      title: "Experimenta el",
      titleHighlight: "poder de la IA",
      subtitle: "Describe tu proyecto y observa nuestros motores IA analizarlo en tiempo real.",
      placeholder: "Describe tu idea de proyecto...",
      analyze: "Analizar proyecto",
      analyzing: "Analizando...",
      results: "Resultados del análisis",
      enginesUsed: "Motores IA utilizados"
    },
    video: {
      sectionTitle: "Ver en acción",
      title: "Video demo",
      titleHighlight: "Plataforma",
      subtitle: "Mira cómo Nexus Design AI transforma ideas en proyectos listos para producir."
    },
    contact: {
      sectionTitle: "Contáctenos",
      title: "Comienza tu",
      titleHighlight: "viaje",
      subtitle: "Estoy abierto a conversaciones con líderes tecnológicos, inversores y equipos de innovación.",
      name: "Nombre completo",
      email: "Correo electrónico",
      company: "Empresa (Opcional)",
      interest: "Tipo de interés",
      interestOptions: {
        partnership: "Asociación",
        investment: "Inversión",
        licensing: "Licencia",
        demo: "Demo del producto",
        other: "Otro"
      },
      message: "Tu mensaje",
      submit: "Enviar mensaje",
      sending: "Enviando...",
      success: "¡Gracias! Te contactaremos pronto.",
      founder: "Fundador e Inventor",
      email_label: "Correo"
    },
    footer: {
      tagline: "La primera plataforma de voz a físico del mundo. Transformando ideas en diseños listos para producir con 8 motores IA especializados.",
      product: "Producto",
      legal: "Legal",
      privacy: "Política de privacidad",
      terms: "Términos de servicio",
      copyright: "Todos los derechos reservados."
    },
    common: {
      login: "Iniciar sesión",
      logout: "Cerrar sesión",
      dashboard: "Panel",
      settings: "Configuración",
      language: "Idioma",
      save: "Guardar",
      cancel: "Cancelar",
      delete: "Eliminar",
      edit: "Editar",
      create: "Crear",
      search: "Buscar",
      loading: "Cargando...",
      error: "Error",
      success: "Éxito"
    }
  },
  ar: {
    mesh3d: {
      title: "نموذج ثلاثي الأبعاد (GLB)",
      ready: "المراجعة مطلوبة",
      cta: "إنشاء نموذج ثلاثي الأبعاد",
      desc: "ينشئ شبكة GLB مرئية أولية من صور المشروع. ليست نموذج CAD بارامترياً ولا هندسة تصنيع ولا توافقاً معتمداً.",
      queued: "في قائمة الانتظار…",
      uploading: "جاري تحميل الصور…",
      generating: "جاري إنشاء النموذج الثلاثي الأبعاد…",
      finalizing: "جاري الإنهاء…",
      working: "جاري العمل…",
      duration: "تختلف مدة المعالجة.",
      download: "تنزيل GLB",
      openTab: "فتح في علامة تبويب جديدة",
      compat: "شبكة GLB مرئية — تحقق من الهندسة والاستيراد في الأدوات المستهدفة.",
      errorPrefix: "خطأ: ",
      errorBalance: "خدمة إنشاء النماذج ثلاثية الأبعاد غير متاحة مؤقتاً. حاول لاحقاً أو تواصل مع الدعم.",
      errorNotConfigured: "إنشاء النماذج ثلاثية الأبعاد غير متاح في هذا النشر. تواصل مع الدعم.",
      noViews: "الصور المفاهيمية ليست جاهزة بعد. حاول مرة أخرى بعد إنشائها.",
      timeout: "انتهت المهلة (3 دقائق)"
    },
    nav: {
      platform: "المنصة",
      engines: "محركات الذكاء الاصطناعي",
      demo: "استوديو التصميم",
      smartGlasses: "النظارات الذكية",
      applications: "التطبيقات",
      contact: "اتصل بنا",
      solutions: "الحلول",
      ar: "تجربة الواقع المعزز",
      scanner: "الماسح الضوئي",
      companies: "الشركات",
      training: "التدريب",
      investors: "المستثمرون",
      more: "المزيد",
      faq: "الأسئلة الشائعة",
      blog: "المدونة",
      caseStudies: "دراسات الحالة"
    },
    hero: {
      badge: "منصة مدعومة بالذكاء الاصطناعي",
      title1: "حوّل أفكارك إلى",
      titleHighlight: "مشاريع هندسية",
      title2: "منظمة",
      subtitle: "صِف فكرتك؛ يساعد النظام في تنظيم المتطلبات ومخرجات CAD الأولية ومسودات خطط الإنتاج. يلزم التحقق البشري المؤهل.",
      cta1: "جرب العرض التجريبي",
      cta2: "اتصل بنا",
      stat1: "تجريبي",
      stat1Label: "القياس مطلوب",
      stat2: "أولي",
      stat2Label: "تقدير التكلفة",
      stat3: "8",
      stat3Label: "محركات ذكاء اصطناعي",
      stat4: "12",
      stat4Label: "لغات الواجهة",
    },
    about: {
      title: "ما هو",
      titleHighlight: "Nexus Design AI",
      subtitle: "حتى بدون معرفة البرمجة أو الهندسة أو أدوات التصميم، يمكنك بناء مشاريع معقدة.",
      description: "فقط صف ما تريد، والنظام يُنشئ تلقائياً:",
      feature1: "نماذج هندسية 3D",
      feature2: "محاكاة وتحسين",
      feature3: "وثائق تقنية أولية (تتطلب التحقق)",
      feature4: "تحليل شامل للسوق",
      conclusion: "يوفر Nexus Design AI مخرجات أولية لدعم القرار؛ وتتطلب النتائج تحققاً بشرياً مؤهلاً.",
    },
    engines: {
      sectionTitle: "التكنولوجيا الأساسية",
      title: "8 محركات",
      titleHighlight: "متخصصة",
      subtitle: "كل محرك متخصص في مرحلة محددة من دورة حياة المشروع."
    },
    smartGlasses: {
      sectionTitle: "ابتكار الجيل القادم",
      title: "النظارات الذكية",
      titleHighlight: "التكامل",
      subtitle: "مفهوم ضمن خارطة الطريق للتكامل مع نظارات صناعية متوافقة.",
      description: "مسارات تجريبية محتملة تخضع لتكامل الأجهزة والمراجعة البشرية المؤهلة:",
      feature1: "المساعدة في مسح الآلات أو المكونات",
      feature2: "تمييز الحالات الشاذة المحتملة لمراجعة المختصين",
      feature3: "عرض إرشادات إصلاح أولية",
      feature4: "اقتراح مفاهيم قطع غيار للمراجعة الهندسية",
      feature5: "عرض قياسات وتحليلات أولية",
      conclusion: "مفهوم ضمن خارطة الطريق فقط — وليس نظاماً معتمداً لاكتشاف الأعطال أو الإصلاح أو السلامة.",
    },
    applications: {
      sectionTitle: "الصناعات",
      title: "تطبيقات",
      titleHighlight: "المؤسسات",
      subtitle: "Nexus Design AI يُحوّل تطوير المشاريع في صناعات متعددة."
    },
    demo: {
      sectionTitle: "عرض مباشر",
      title: "اختبر قوة",
      titleHighlight: "الذكاء الاصطناعي",
      subtitle: "صف مشروعك وشاهد محركاتنا تحلله في الوقت الفعلي.",
      placeholder: "صف فكرة مشروعك...",
      analyze: "تحليل المشروع",
      analyzing: "جاري التحليل...",
      results: "نتائج التحليل",
      enginesUsed: "المحركات المستخدمة"
    },
    video: {
      sectionTitle: "شاهده أثناء العمل",
      title: "فيديو",
      titleHighlight: "توضيحي",
      subtitle: "شاهد مخرجات هندسية أولية تتطلب المراجعة من Nexus Design AI.",
    },
    contact: {
      sectionTitle: "تواصل معنا",
      title: "ابدأ",
      titleHighlight: "رحلتك",
      subtitle: "أنا منفتح على الحوار مع قادة التكنولوجيا والمستثمرين وفرق الابتكار.",
      name: "الاسم الكامل",
      email: "البريد الإلكتروني",
      company: "الشركة (اختياري)",
      interest: "نوع الاهتمام",
      interestOptions: {
        partnership: "شراكة",
        investment: "استثمار",
        licensing: "ترخيص",
        demo: "عرض المنتج",
        other: "أخرى"
      },
      message: "رسالتك",
      submit: "إرسال",
      sending: "جاري الإرسال...",
      success: "شكراً! سنتواصل معك قريباً.",
      founder: "المؤسس والمخترع",
      email_label: "البريد"
    },
    footer: {
      tagline: "منصة مدعومة بالذكاء الاصطناعي لمخرجات هندسية أولية منظمة تتطلب مراجعة بشرية.",
      product: "المنتج",
      legal: "قانوني",
      privacy: "سياسة الخصوصية",
      terms: "شروط الخدمة",
      copyright: "جميع الحقوق محفوظة."
    },
    common: {
      login: "تسجيل الدخول",
      logout: "تسجيل الخروج",
      dashboard: "لوحة التحكم",
      settings: "الإعدادات",
      language: "اللغة",
      save: "حفظ",
      cancel: "إلغاء",
      delete: "حذف",
      edit: "تعديل",
      create: "إنشاء",
      search: "بحث",
      loading: "جاري التحميل...",
      error: "خطأ",
      success: "نجاح"
    }
  },
  zh: {
    mesh3d: {
      title: "3D 模型 (GLB)",
      ready: "需要审核",
      cta: "生成 3D 网格",
      desc: "根据项目图像生成初步的可视化 GLB 网格。它不是参数化 CAD、制造几何体或经验证的互操作结果。",
      queued: "排队中…",
      uploading: "正在上传图像…",
      generating: "正在生成 3D 网格…",
      finalizing: "正在完成…",
      working: "处理中…",
      duration: "处理时间会有所不同。",
      download: "下载 GLB",
      openTab: "在新标签页中打开",
      compat: "可视化 GLB 网格——请在目标工具中验证几何体和导入结果。",
      errorPrefix: "错误:",
      errorBalance: "3D 生成服务暂时不可用。请稍后重试或联系支持。",
      errorNotConfigured: "此部署未提供 3D 生成功能。请联系支持。",
      noViews: "概念图像尚未准备好。生成后请重试。",
      timeout: "超时(3 分钟)"
    },
    nav: {
      platform: "平台",
      engines: "AI引擎",
      demo: "设计工作室",
      smartGlasses: "智能眼镜",
      applications: "应用",
      contact: "联系我们",
      solutions: "解决方案",
      ar: "AR体验",
      scanner: "扫描仪",
      companies: "公司",
      training: "培训",
      investors: "投资者",
      more: "更多",
      faq: "常见问题",
      blog: "博客",
      caseStudies: "案例研究"
    },
    hero: {
      badge: "AI驱动平台",
      title1: "将创意转化为",
      titleHighlight: "结构化工程",
      title2: "项目",
      subtitle: "描述您的想法；系统协助形成结构化需求、初步的 CAD 导向输出和生产计划草案。所有结果均需合格人员验证。",
      cta1: "试用演示",
      cta2: "联系我们",
      stat1: "试点",
      stat1Label: "需要测量验证",
      stat2: "初步",
      stat2Label: "成本估算",
      stat3: "8",
      stat3Label: "AI引擎",
      stat4: "12",
      stat4Label: "界面语言",
    },
    about: {
      title: "什么是",
      titleHighlight: "Nexus Design AI",
      subtitle: "即使不懂编程、工程或设计工具，也可以构建复杂项目。",
      description: "只需描述您想要的，系统会自动创建：",
      feature1: "3D工程模型",
      feature2: "仿真与优化",
      feature3: "初步技术文档（需要验证）",
      feature4: "全面的市场分析",
      conclusion: "Nexus Design AI 提供早期工程决策支持；所有结果均需合格人员验证。",
    },
    engines: {
      sectionTitle: "核心技术",
      title: "8个专业",
      titleHighlight: "AI引擎",
      subtitle: "每个引擎专注于项目生命周期的特定阶段。"
    },
    smartGlasses: {
      sectionTitle: "下一代创新",
      title: "智能眼镜",
      titleHighlight: "集成",
      subtitle: "与兼容工业智能眼镜硬件集成的路线图概念。",
      description: "潜在试点流程取决于硬件集成和合格人员审核：",
      feature1: "协助扫描机器或组件",
      feature2: "标记可能的异常供专业人员审核",
      feature3: "显示初步维修指导",
      feature4: "提供备件概念供工程审核",
      feature5: "显示初步测量和分析",
      conclusion: "仅为路线图概念，并非经验证的现场故障检测、维修或安全系统。",
    },
    applications: {
      sectionTitle: "行业",
      title: "企业",
      titleHighlight: "应用",
      subtitle: "Nexus Design AI在多个行业转变项目开发。"
    },
    demo: {
      sectionTitle: "在线演示",
      title: "体验",
      titleHighlight: "AI能力",
      subtitle: "描述您的项目，实时观看我们的AI引擎分析它。",
      placeholder: "描述您的项目想法...",
      analyze: "分析项目",
      analyzing: "分析中...",
      results: "分析结果",
      enginesUsed: "使用的AI引擎"
    },
    video: {
      sectionTitle: "实际演示",
      title: "平台",
      titleHighlight: "演示视频",
      subtitle: "观看Nexus Design AI如何将创意转化为可生产的项目。"
    },
    contact: {
      sectionTitle: "联系我们",
      title: "开始您的",
      titleHighlight: "旅程",
      subtitle: "我正在与技术领袖、投资者和创新团队展开对话。",
      name: "全名",
      email: "电子邮件",
      company: "公司（可选）",
      interest: "兴趣类型",
      interestOptions: {
        partnership: "合作伙伴",
        investment: "投资",
        licensing: "许可",
        demo: "产品演示",
        other: "其他"
      },
      message: "您的消息",
      submit: "发送消息",
      sending: "发送中...",
      success: "谢谢！我们会尽快联系您。",
      founder: "创始人兼发明者",
      email_label: "邮箱"
    },
    footer: {
      tagline: "世界上第一个语音到实物平台。用8个专业AI引擎将创意转化为可生产的设计。",
      product: "产品",
      legal: "法律",
      privacy: "隐私政策",
      terms: "服务条款",
      copyright: "版权所有。"
    },
    common: {
      login: "登录",
      logout: "退出",
      dashboard: "控制面板",
      settings: "设置",
      language: "语言",
      save: "保存",
      cancel: "取消",
      delete: "删除",
      edit: "编辑",
      create: "创建",
      search: "搜索",
      loading: "加载中...",
      error: "错误",
      success: "成功"
    }
  },
  ja: {
    mesh3d: {
      title: "3Dモデル (GLB)",
      ready: "レビューが必要",
      cta: "3Dメッシュを生成",
      desc: "プロジェクト画像から予備的なビジュアル GLB メッシュを生成します。パラメトリック CAD、製造用ジオメトリ、または検証済み相互運用性ではありません。",
      queued: "キュー待機中…",
      uploading: "画像をアップロード中…",
      generating: "3Dメッシュを生成中…",
      finalizing: "完了処理中…",
      working: "処理中…",
      duration: "処理時間は変動します。",
      download: "GLBをダウンロード",
      openTab: "新しいタブで開く",
      compat: "ビジュアル GLB メッシュ — 対象ツールで形状とインポート結果を確認してください。",
      errorPrefix: "エラー: ",
      errorBalance: "3D生成サービスは一時的に利用できません。後でもう一度試すか、サポートに連絡してください。",
      errorNotConfigured: "この環境では3D生成を利用できません。サポートに連絡してください。",
      noViews: "コンセプト画像はまだ準備できていません。生成後に再試行してください。",
      timeout: "タイムアウト(3分)"
    },
    nav: {
      platform: "プラットフォーム",
      engines: "AIエンジン",
      demo: "デザインスタジオ",
      smartGlasses: "スマートグラス",
      applications: "アプリケーション",
      contact: "お問い合わせ",
      solutions: "ソリューション",
      ar: "AR体験",
      scanner: "スキャナー",
      companies: "企業",
      training: "トレーニング",
      investors: "投資家",
      more: "もっと見る",
      faq: "よくある質問",
      blog: "ブログ",
      caseStudies: "事例研究"
    },
    hero: {
      badge: "AI駆動プラットフォーム",
      title1: "アイデアを",
      titleHighlight: "構造化された",
      title2: "エンジニアリング案件に",
      subtitle: "アイデアを説明すると、要件整理、予備的なCAD指向出力、製造計画案の作成を支援します。専門家による検証が必要です。",
      cta1: "デモを試す",
      cta2: "お問い合わせ",
      stat1: "パイロット",
      stat1Label: "測定が必要",
      stat2: "予備",
      stat2Label: "コスト見積り",
      stat3: "8",
      stat3Label: "AIエンジン",
      stat4: "12",
      stat4Label: "表示言語",
    },
    about: {
      title: "とは",
      titleHighlight: "Nexus Design AI",
      subtitle: "コーディング、エンジニアリング、デザインツールの知識がなくても複雑なプロジェクトを構築できます。",
      description: "欲しいものを説明するだけで、システムが自動的に作成します：",
      feature1: "3Dエンジニアリングモデル",
      feature2: "シミュレーションと最適化",
      feature3: "予備的な技術文書（検証が必要）",
      feature4: "包括的な市場分析",
      conclusion: "Nexus Design AI は初期エンジニアリング向けの予備的な意思決定支援を提供し、結果には専門家の検証が必要です。",
    },
    common: {
      login: "ログイン",
      logout: "ログアウト",
      dashboard: "ダッシュボード",
      settings: "設定",
      language: "言語",
      save: "保存",
      cancel: "キャンセル",
      delete: "削除",
      edit: "編集",
      create: "作成",
      search: "検索",
      loading: "読み込み中...",
      error: "エラー",
      success: "成功"
    }
  },
  ko: {
    mesh3d: {
      title: "3D 모델 (GLB)",
      ready: "검토 필요",
      cta: "3D 메시 생성",
      desc: "프로젝트 이미지에서 예비 시각화 GLB 메시를 생성합니다. 파라메트릭 CAD, 제조용 형상 또는 검증된 상호운용성 결과가 아닙니다.",
      queued: "대기열에 있음…",
      uploading: "이미지 업로드 중…",
      generating: "3D 메시 생성 중…",
      finalizing: "마무리 중…",
      working: "작업 중…",
      duration: "처리 시간은 달라질 수 있습니다.",
      download: "GLB 다운로드",
      openTab: "새 탭에서 열기",
      compat: "시각화 GLB 메시 — 대상 도구에서 형상과 가져오기 결과를 확인하세요.",
      errorPrefix: "오류: ",
      errorBalance: "3D 생성 서비스를 일시적으로 사용할 수 없습니다. 나중에 다시 시도하거나 지원팀에 문의하세요.",
      errorNotConfigured: "이 배포에서는 3D 생성을 사용할 수 없습니다. 지원팀에 문의하세요.",
      noViews: "개념 이미지가 아직 준비되지 않았습니다. 생성 후 다시 시도하세요.",
      timeout: "시간 초과 (3분)"
    },
    nav: {
      platform: "플랫폼",
      engines: "AI 엔진",
      demo: "디자인 스튜디오",
      smartGlasses: "스마트 안경",
      applications: "응용 프로그램",
      contact: "문의",
      solutions: "솔루션",
      ar: "AR 체험",
      scanner: "스캐너",
      companies: "기업",
      training: "교육",
      investors: "투자자",
      more: "더보기",
      faq: "자주 묻는 질문",
      blog: "블로그",
      caseStudies: "사례 연구"
    },
    hero: {
      badge: "AI 기반 플랫폼",
      title1: "아이디어를",
      titleHighlight: "구조화된",
      title2: "엔지니어링 프로젝트로",
      subtitle: "아이디어를 설명하면 요구사항, 예비 CAD 지향 결과 및 생산 계획 초안을 구성하도록 지원합니다. 자격을 갖춘 전문가의 검증이 필요합니다.",
      cta1: "데모 체험",
      cta2: "문의하기",
      stat1: "파일럿",
      stat1Label: "측정 필요",
      stat2: "예비",
      stat2Label: "비용 추정",
      stat3: "8",
      stat3Label: "AI 엔진",
      stat4: "12",
      stat4Label: "인터페이스 언어",
    },
    common: {
      login: "로그인",
      logout: "로그아웃",
      dashboard: "대시보드",
      settings: "설정",
      language: "언어",
      save: "저장",
      cancel: "취소",
      delete: "삭제",
      edit: "편집",
      create: "생성",
      search: "검색",
      loading: "로딩 중...",
      error: "오류",
      success: "성공"
    }
  },
  pt: {
    mesh3d: {
      title: "Modelo 3D (GLB)",
      ready: "Revisão necessária",
      cta: "Gerar Modelo 3D",
      desc: "Gera uma malha GLB visual preliminar a partir das imagens do projeto. Não é CAD paramétrico, geometria de fabricação nem interoperabilidade validada.",
      queued: "Na fila…",
      uploading: "Enviando imagens…",
      generating: "Gerando modelo 3D…",
      finalizing: "Finalizando…",
      working: "Trabalhando…",
      duration: "O tempo de processamento varia.",
      download: "Baixar GLB",
      openTab: "Abrir em Nova Aba",
      compat: "Malha GLB visual — verifique a geometria e a importação nas ferramentas de destino.",
      errorPrefix: "Erro: ",
      errorBalance: "O serviço de geração 3D está temporariamente indisponível. Tente novamente mais tarde ou contate o suporte.",
      errorNotConfigured: "A geração 3D não está disponível nesta implantação. Contate o suporte.",
      noViews: "As imagens conceituais ainda não estão prontas. Tente novamente após serem geradas.",
      timeout: "Tempo esgotado (3 min)"
    },
    nav: {
      platform: "Plataforma",
      engines: "Motores IA",
      projects: "Proyectos",
      demo: "Estúdio de Design",
      smartGlasses: "Óculos Inteligentes",
      applications: "Aplicações",
      contact: "Contato",
      solutions: "Soluções",
      ar: "Experiência AR",
      scanner: "Scanner",
      companies: "Empresas",
      training: "Treinamento",
      investors: "Investidores",
      more: "Mais",
      faq: "FAQ",
      blog: "Blog",
      caseStudies: "Estudos de Caso"
    },
    hero: {
      badge: "Plataforma com IA",
      title1: "Transforme ideias em",
      titleHighlight: "projetos de engenharia",
      title2: "estruturados",
      subtitle: "Descreva sua ideia; o sistema ajuda a estruturar requisitos, resultados preliminares orientados a CAD e rascunhos de produção. É necessária validação humana qualificada.",
      cta1: "Experimentar demo",
      cta2: "Contate-nos",
      stat1: "Piloto",
      stat1Label: "Medição necessária",
      stat2: "Preliminar",
      stat2Label: "Estimativa de custos",
      stat3: "8",
      stat3Label: "Motores IA",
      stat4: "12",
      stat4Label: "Idiomas da interface",
    },
    common: {
      login: "Entrar",
      logout: "Sair",
      dashboard: "Painel",
      settings: "Configurações",
      language: "Idioma",
      save: "Salvar",
      cancel: "Cancelar",
      delete: "Excluir",
      edit: "Editar",
      create: "Criar",
      search: "Pesquisar",
      loading: "Carregando...",
      error: "Erro",
      success: "Sucesso"
    }
  },
  ru: {
    mesh3d: {
      title: "3D-модель (GLB)",
      ready: "Требуется проверка",
      cta: "Создать 3D-модель",
      desc: "Создаёт предварительную визуальную GLB-сетку по изображениям проекта. Это не параметрическая CAD-модель, не производственная геометрия и не подтверждённая совместимость.",
      queued: "В очереди…",
      uploading: "Загрузка изображений…",
      generating: "Генерация 3D-модели…",
      finalizing: "Завершение…",
      working: "Обработка…",
      duration: "Время обработки может отличаться.",
      download: "Скачать GLB",
      openTab: "Открыть в новой вкладке",
      compat: "Визуальная GLB-сетка — проверьте геометрию и импорт в целевых инструментах.",
      errorPrefix: "Ошибка: ",
      errorBalance: "Сервис 3D-генерации временно недоступен. Повторите позже или обратитесь в поддержку.",
      errorNotConfigured: "3D-генерация недоступна в этом развёртывании. Обратитесь в поддержку.",
      noViews: "Концепт-изображения ещё не готовы. Попробуйте снова после их генерации.",
      timeout: "Время ожидания истекло (3 мин)"
    },
    nav: {
      platform: "Платформа",
      engines: "AI Движки",
      demo: "Студия Дизайна",
      smartGlasses: "Умные Очки",
      applications: "Приложения",
      contact: "Контакты",
      solutions: "Решения",
      ar: "AR Опыт",
      scanner: "Сканер",
      companies: "Компании",
      training: "Обучение",
      investors: "Инвесторы",
      more: "Ещё",
      faq: "FAQ",
      blog: "Блог",
      caseStudies: "Кейсы"
    },
    hero: {
      badge: "Платформа на базе ИИ",
      title1: "Превращайте идеи в",
      titleHighlight: "структурированные",
      title2: "инженерные проекты",
      subtitle: "Опишите идею; система помогает сформировать требования, предварительные CAD-ориентированные результаты и черновики производственных планов. Требуется проверка квалифицированным специалистом.",
      cta1: "Попробовать демо",
      cta2: "Свяжитесь с нами",
      stat1: "Пилот",
      stat1Label: "Нужны измерения",
      stat2: "Предварительно",
      stat2Label: "Оценка затрат",
      stat3: "8",
      stat3Label: "AI Движков",
      stat4: "12",
      stat4Label: "Языки интерфейса",
    },
    common: {
      login: "Войти",
      logout: "Выйти",
      dashboard: "Панель управления",
      settings: "Настройки",
      language: "Язык",
      save: "Сохранить",
      cancel: "Отмена",
      delete: "Удалить",
      edit: "Редактировать",
      create: "Создать",
      search: "Поиск",
      loading: "Загрузка...",
      error: "Ошибка",
      success: "Успех"
    }
  },
  hi: {
    mesh3d: {
      title: "3D मॉडल (GLB)",
      ready: "समीक्षा आवश्यक",
      cta: "3D मॉडल बनाएं",
      desc: "प्रोजेक्ट छवियों से प्रारंभिक दृश्य GLB मेश बनाता है। यह पैरामीट्रिक CAD, विनिर्माण ज्यामिति या सत्यापित इंटरऑपरेबिलिटी नहीं है।",
      queued: "कतार में…",
      uploading: "छवियाँ अपलोड हो रही हैं…",
      generating: "3D मॉडल बनाया जा रहा है…",
      finalizing: "अंतिम रूप दिया जा रहा है…",
      working: "कार्य चल रहा है…",
      duration: "प्रोसेसिंग समय बदल सकता है।",
      download: "GLB डाउनलोड करें",
      openTab: "नए टैब में खोलें",
      compat: "दृश्य GLB मेश — लक्ष्य टूल में ज्यामिति और आयात परिणाम सत्यापित करें।",
      errorPrefix: "त्रुटि: ",
      errorBalance: "3D जनरेशन सेवा अस्थायी रूप से उपलब्ध नहीं है। बाद में प्रयास करें या सहायता से संपर्क करें।",
      errorNotConfigured: "इस डिप्लॉयमेंट में 3D जनरेशन उपलब्ध नहीं है। सहायता से संपर्क करें।",
      noViews: "कॉन्सेप्ट छवियाँ अभी तैयार नहीं हैं। उत्पन्न होने के बाद पुनः प्रयास करें।",
      timeout: "समय समाप्त (3 मिनट)"
    },
    nav: {
      platform: "प्लेटफ़ॉर्म",
      engines: "AI इंजन",
      demo: "डिज़ाइन स्टूडियो",
      smartGlasses: "स्मार्ट चश्मा",
      applications: "अनुप्रयोग",
      contact: "संपर्क",
      solutions: "समाधान",
      ar: "AR अनुभव",
      scanner: "स्कैनर",
      companies: "कंपनियां",
      training: "प्रशिक्षण",
      investors: "निवेशक",
      more: "और देखें",
      faq: "सामान्य प्रश्न",
      blog: "ब्लॉग",
      caseStudies: "केस स्टडी"
    },
    hero: {
      badge: "AI संचालित प्लेटफ़ॉर्म",
      title1: "विचारों को",
      titleHighlight: "संरचित",
      title2: "इंजीनियरिंग परियोजनाओं में",
      subtitle: "अपना विचार बताएं; सिस्टम आवश्यकताओं, प्रारंभिक CAD-उन्मुख आउटपुट और उत्पादन योजना के मसौदे बनाने में सहायता करता है। योग्य मानव सत्यापन आवश्यक है।",
      cta1: "डेमो आज़माएं",
      cta2: "संपर्क करें",
      stat1: "पायलट",
      stat1Label: "मापन आवश्यक",
      stat2: "प्रारंभिक",
      stat2Label: "लागत अनुमान",
      stat3: "8",
      stat3Label: "AI इंजन",
      stat4: "12",
      stat4Label: "इंटरफ़ेस भाषाएं",
    },
    common: {
      login: "लॉगिन",
      logout: "लॉगआउट",
      dashboard: "डैशबोर्ड",
      settings: "सेटिंग्स",
      language: "भाषा",
      save: "सहेजें",
      cancel: "रद्द करें",
      delete: "हटाएं",
      edit: "संपादित करें",
      create: "बनाएं",
      search: "खोजें",
      loading: "लोड हो रहा है...",
      error: "त्रुटि",
      success: "सफलता"
    }
  }
};

export const industries = {
  en: [
    { id: "aerospace", name: "Aerospace & Defense", description: "Aircraft, satellites, defense systems" },
    { id: "automotive", name: "Automotive & EV", description: "Vehicles, electric cars, components" },
    { id: "robotics", name: "Robotics & Manufacturing", description: "Automation, production lines" },
    { id: "industrial", name: "Industrial Engineering", description: "Heavy machinery, systems" },
    { id: "architecture", name: "Architecture & Construction", description: "Buildings, infrastructure" },
    { id: "medical", name: "Medical Devices & R&D", description: "Healthcare equipment, research" },
    { id: "maintenance", name: "Field Maintenance & Smart Factories", description: "IoT, predictive maintenance" }
  ],
  tr: [
    { id: "aerospace", name: "Havacılık & Savunma", description: "Uçaklar, uydular, savunma sistemleri" },
    { id: "automotive", name: "Otomotiv & EV", description: "Araçlar, elektrikli arabalar, bileşenler" },
    { id: "robotics", name: "Robotik & Üretim", description: "Otomasyon, üretim hatları" },
    { id: "industrial", name: "Endüstriyel Mühendislik", description: "Ağır makineler, sistemler" },
    { id: "architecture", name: "Mimarlık & İnşaat", description: "Binalar, altyapı" },
    { id: "medical", name: "Tıbbi Cihazlar & Ar-Ge", description: "Sağlık ekipmanları, araştırma" },
    { id: "maintenance", name: "Saha Bakımı & Akıllı Fabrikalar", description: "IoT, öngörücü bakım" }
  ]
};

export const aiEngines = {
  en: [
    { id: 1, name: "Data Collection Engine", description: "Multi-source data fusion with real-time streaming.", features: ["Web Scraping", "API Integration", "Real-time"], color: "from-blue-600 to-cyan-500" },
    { id: 2, name: "Company Profile Analysis", description: "AI-powered organizational capability scoring.", features: ["Financial Analysis", "Market Position", "Assessment"], color: "from-violet-600 to-purple-500" },
    { id: 3, name: "Industry & Trend Analysis", description: "Market dynamics tracking with predictions.", features: ["Market Research", "Consumer Behavior", "Tracking"], color: "from-blue-600 to-indigo-500" },
    { id: 4, name: "Competitive Analysis", description: "Deep competitor profiling and strategy.", features: ["Competitor Matrix", "Pricing Analysis", "Detection"], color: "from-fuchsia-600 to-pink-500" },
    { id: 5, name: "Solution Generation", description: "Multi-objective optimization algorithms.", features: ["Tech Recommendations", "Resource Planning", "Optimization"], color: "from-amber-500 to-orange-500" },
    { id: 6, name: "Voice Command & NLP", description: "Multilingual transformer-based NLP; provider and language coverage must be validated per deployment.", features: ["Speech Recognition", "Intent Analysis", "Understanding"], color: "from-green-500 to-emerald-500" },
    { id: 7, name: "3D Modeling & Code Gen", description: "Parametric-generative hybrid modeling.", features: ["3D Modeling", "Code Generation", "Export"], color: "from-blue-500 to-violet-600" },
    { id: 8, name: "Production Optimization", description: "Supply chain and manufacturing optimization.", features: ["Path Analysis", "Scheduling", "Quality Control"], color: "from-rose-500 to-red-500" }
  ],
  tr: [
    { id: 1, name: "Veri Toplama Motoru", description: "Gerçek zamanlı akış ile çoklu kaynak veri füzyonu.", features: ["Web Kazıma", "API Entegrasyonu", "Gerçek Zamanlı"], color: "from-blue-600 to-cyan-500" },
    { id: 2, name: "Şirket Profili Analizi", description: "AI destekli organizasyonel yetenek puanlama.", features: ["Finansal Analiz", "Pazar Konumu", "Değerlendirme"], color: "from-violet-600 to-purple-500" },
    { id: 3, name: "Endüstri & Trend Analizi", description: "Öngörülerle pazar dinamikleri takibi.", features: ["Pazar Araştırması", "Tüketici Davranışı", "Takip"], color: "from-blue-600 to-indigo-500" },
    { id: 4, name: "Rekabet Analizi", description: "Derin rakip profilleme ve strateji.", features: ["Rakip Matrisi", "Fiyat Analizi", "Tespit"], color: "from-fuchsia-600 to-pink-500" },
    { id: 5, name: "Çözüm Üretimi", description: "Çok amaçlı optimizasyon algoritmaları.", features: ["Teknoloji Önerileri", "Kaynak Planlaması", "Optimizasyon"], color: "from-amber-500 to-orange-500" },
    { id: 6, name: "Sesli Komut & NLP", description: "Çok dilli transformer tabanlı NLP; sağlayıcı ve dil kapsamı her dağıtımda doğrulanmalıdır.", features: ["Konuşma Tanıma", "Niyet Analizi", "Anlama"], color: "from-green-500 to-emerald-500" },
    { id: 7, name: "3D Modelleme & Kod Üretimi", description: "Parametrik-üretken hibrit modelleme.", features: ["3D Modelleme", "Kod Üretimi", "Dışa Aktarım"], color: "from-blue-500 to-violet-600" },
    { id: 8, name: "Üretim Optimizasyonu", description: "Tedarik zinciri ve üretim optimizasyonu.", features: ["Yol Analizi", "Planlama", "Kalite Kontrol"], color: "from-rose-500 to-red-500" }
  ]
};
